import type { VideoFrameAlign } from "./types";

export function resolveVideoFrameAlignment(
  align: VideoFrameAlign,
): "flex-start" | "center" | "flex-end" {
  if (align === "center") return "center";
  if (align === "end") return "flex-end";
  return "flex-start";
}
